import {
  ON_MATERIAL_READ,
  ON_MATERIAL_READING,
  ON_MATERIAL_VALUE_CHANGE,
} from '../actions/types';

const INITIAL_STATE = { materials: [], loading: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_MATERIAL_VALUE_CHANGE:
      return { ...state, ...action.payload };
    case ON_MATERIAL_READING:
      return { ...state, loading: true };
    case ON_MATERIAL_READ:
      return { ...state, materials: action.payload, loading: false };

    default:
      return state;
  }
};
